import { Box, Stack, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { useGlobalModals } from 'src/contexts/global-modals';

import { ComponentLoader } from '../ComponentLoader';
import { Modal } from '../Modal';

export const LoadingModal: FC = memo(() => {
  const { loadingModal } = useGlobalModals();

  const open = loadingModal.opened;
  const title = loadingModal.title;
  const description = loadingModal.description;

  return (
    <Modal
      opened={open}
      onClose={close}
      title={''}
      size="md"
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      centered
    >
      <Box pt="lg" pb="lg">
        <Stack gap="md" align="center">
          <ComponentLoader size="xl" height="auto" />

          {title && (
            <Text fw={600} mt="lg" size="xl">
              {title}
            </Text>
          )}

          {description && <Text size="sm">{description}</Text>}
        </Stack>
      </Box>
    </Modal>
  );
});
